import { forwardRef } from 'react';

// Styles
import styles from './TableWrapper.module.css';

// Utils
import cn from '../../../utils/cn';

// Components
import { Skeleton } from '../../atoms/Skeleton/Skeleton';

/**
 * TableWrapperSkeleton component
 * @returns {JSX.Element}
 */
function TableWrapperSkeleton() {
  return (
    <div className={styles['table-wrapper-skeleton']}>
      <Skeleton shape="rectangle" width="100%" height="48px" theme="table" />
      <Skeleton shape="rectangle" width="100%" height="25vh" theme="table" />
      <Skeleton shape="rectangle" width="100%" height="20vh" theme="table" />
    </div>
  );
}

const TableWrapper = forwardRef(
  /**
   * TableWrapper component
   * @param {object} props
   * @param {JSX.Element | null} [props.children]
   * @param {boolean} [props.isLoading]
   * @param {React.Ref<HTMLDivElement>} ref - Ref to the wrapper element
   * @returns {JSX.Element}
   */
  ({ children = null, isLoading = false }, ref) => (
    <div ref={ref} className={cn([styles['table-wrapper'], isLoading && styles.loading])}>
      {isLoading ? <TableWrapperSkeleton /> : children}
    </div>
  ),
);

export default TableWrapper;
